<template>
    <div :class="outerClass || undefined">
      <Panel
        :toggleable="toggleable"
        :collapsed="collapsed"
        :class="panelClass"
      >
        <template v-if="$slots.header" #header>
          <slot name="header" />
        </template>
        <template v-else #header>
          <label>
            <Icon v-if="icon" type="favicon" :icon="icon" class="Icon" />
            <slot name="title">{{ title ? $t(title) : '' }}</slot>
          </label>
        </template>
  
        <template v-if="$slots.icons" #icons>
          <slot name="icons" />
        </template>
  
        <slot />
      </Panel>
    </div>
  </template>

<script>
export default {
  name: "InfoPanel",
  props: {
    icon: { type: String, default: "" },
    title: { type: String, default: "" },
    toggleable: { type: Boolean, default: false },
    collapsed: { type: Boolean, default: undefined },
    col: { type: String, default: "" },             
    wrapperClass: { type: String, default: "" }, 
    panelClass: { type: String, default: "invoice-panel" }, 
  },
  computed: {
    outerClass() {
      return [this.col, this.wrapperClass].filter(Boolean).join(" ");
    },
  },
};
</script>